import { Component, ElementRef, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { getConfirmationDi } from '@cfg/services/confirmation-di';
import { getNotificationDi } from '@cfg/services/notification-di';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { getTranslationDi } from '@cfg/i18n/translation-di';
import { getDialogDi } from '@cfg/services/dialog-di';
import { LoadingOverlayComponent } from './shared/loading-overlay.component';
import { HttpLoadingStateService } from 'src/app/infrastructure/state/http-loading-state.service';

/**
 * Componente inicial de la aplicación, aquí se carga el router-outlet
 */
@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    ToastModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    LoadingOverlayComponent
  ],
  providers: [
    getConfirmationDi,
    getNotificationDi,
    getTranslationDi,
    getDialogDi
  ],
  template: `
    <app-loading-overlay [blocked]="httpLoadingState.isLoading()" />
    <router-outlet></router-outlet>
    <p-confirmDialog />
    <p-toast />
  `,
  styles: []
})
export class AppComponent implements OnInit {
  readonly httpLoadingState = inject(HttpLoadingStateService);

  /**
   * Crea una instancia de AppComponent.
   * @param _elementRef Referencia al elemento del componente.
   */
  constructor(private _elementRef: ElementRef) {}

  /**
   * Inicializa el componente y elimina el atributo ng-version del elemento
   */
  ngOnInit(): void {
    (this._elementRef.nativeElement as HTMLElement).removeAttribute(
      'ng-version'
    );
  }
}
